export enum ReferralAgentLinkEnum {
    default,
    success,
    error,
}